import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import MainHeader from 'components/templateParts/MainHeader';
import dataProvider, { UPDATE, UPLOAD_FILE_S3 } from "providers/dataProvider";
import config from 'config';
import authStorage from 'providers/authStorage';
import withForm from 'withForm';
import { createConfig } from "config/resources/collaboratorsResource";
import { compose } from 'redux'
import { withNotificationCenter } from 'NotificationCenter'
import BaseForm from 'components/ui_components/BaseForm/BaseForm';
import BaseFormControls from 'components/ui_components/BaseFormControls/BaseFormControls';
import style from './CollaboratorEdit.module.scss'
const styles = () => ({
  main: {
    margin: '32px 26px 0',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '30px 15px 30px'
  }
});

// const inputsGroupsById = createConfig.inputsGroupsById;
const inputsGroupsByHash = createConfig.inputsGroupsByHash;

const CollaboratorEdit = (props) => {
  const { classes, inputsById, inputsByHash, handleInputs } = props;

  const handleSubmit = () => {
    const { notificationCenter, history, isFormValid, inputsById, inputsByHash, resetErrors, getSubmitData } = props;

    if (isFormValid()) {
      resetErrors();
       const data = getSubmitData(true, true, true);


      inputsById.forEach((id) => {
        const inputValue = inputsByHash[id].value;
        if (inputValue === null) return;
        data[id] = inputValue
      })

      const submit = async () => {
        try {
          const logoInput = inputsByHash && inputsByHash.colaLogoFilename;
          if (logoInput && logoInput.value instanceof File) {
            const file = logoInput.value;
            const originalName = file.name;

            const presignUrl = `${config.apiUrl}/collaborators/upload_logo?fileName=${encodeURIComponent(originalName)}`;
            const uploadInitResponse = await fetch(presignUrl, {
              method: 'GET',
              headers: {
                'token': authStorage.getToken(),
                'Accept': 'application/json'
              }
            });

            if (!uploadInitResponse.ok) {
              notificationCenter.show(`Upload init failed (${uploadInitResponse.status})`, 'error');
              return;
            }

            const uploadInit = await uploadInitResponse.json();
            const initData = uploadInit.data || uploadInit || {};
            console.debug('upload_logo init response (edit):', initData);

            if (initData.fields && initData.url) {
              const s3Response = await dataProvider(UPLOAD_FILE_S3, initData.url, {
                data: { ...initData.fields, downloadFile: file }
              });

              if (s3Response.status !== 204) {
                notificationCenter.show('S3 upload failed', 'error');
                return;
              }
            } else {
              const presignedUrl = initData.presignedUrl || initData.url;
              if (!presignedUrl) {
                notificationCenter.show('Invalid upload init response', 'error');
                return;
              }

              const s3Response = await fetch(presignedUrl, {
                method: 'PUT',
                headers: { 'Content-Type': file.type || 'application/octet-stream' },
                body: file,
              });

              if (!s3Response.ok) {
                notificationCenter.show(`S3 upload failed (${s3Response.status})`, 'error');
                return;
              }
            }

            data.colaLogoFilename = initData.newFileName || '';
            data.colaLogoOriginalName = originalName;
            
            // Update the display field to show original filename
            if (inputsByHash && inputsByHash.colaLogoOriginalFileName) {
              inputsByHash.colaLogoOriginalFileName.value = originalName;
            }
          }

          // Ensure checkbox value for report logo is sent as string "1"/"0"
          if (data.hasOwnProperty('colaIsReportLogo')) {
            try {
              data.colaIsReportLogo = data.colaIsReportLogo ? '1' : '0';
            } catch (e) {
              data.colaIsReportLogo = String(data.colaIsReportLogo || '0');
            }
          }

          const response = await dataProvider(UPDATE, 'collaborators', { data: data, id: props.id });
          notificationCenter.show('Successfully updated', 'info');
          history.push('/collaborators/' + response.data.id + '/show');
        } catch (error) {
          console.error('Update collaborator error:', error);
          if (error && error.response) {
            console.error('Update collaborator response data:', error.response.data);
            console.error('Update collaborator response status:', error.response.status);
          }
          const serverMessage = (error && error.response && error.response.data && (error.response.data.message || JSON.stringify(error.response.data))) || error?.message || 'Unknown error';
          notificationCenter.show(serverMessage, 'warning');
        }
      };

      submit();
    }
  }

  return (
    <div>
      <MainHeader title="Edit Collaborator"/>
      <div className={classes.main}>
        {/* Info Section */}
        <div className={style.form}>
          <BaseForm
            inputsById={inputsById}
            inputsByHash={inputsByHash}
            handleInputs={handleInputs}
            inputsGroupsById={['group1']}
            inputsGroupsByHash={inputsGroupsByHash}
            rootStyles={'display: flex; flex-wrap: wrap;'}
          />
        </div>

        {/* Bottom Section - Three Columns */}
        <div className={style.form}>
          <BaseForm
            inputsById={inputsById}
            inputsByHash={inputsByHash}
            handleInputs={handleInputs}
            inputsGroupsById={['group4', 'group2', 'group5']}
            inputsGroupsByHash={inputsGroupsByHash}
            rootStyles={'width: 33.333%;margin-left: 0rem;'}
          />
        </div>
           {/* Logo Section */}
        <div className={style.form}>
          <BaseForm
            inputsById={inputsById}
            inputsByHash={inputsByHash}
            handleInputs={handleInputs}
            inputsGroupsById={['groupLogo']}
            inputsGroupsByHash={inputsGroupsByHash}
            rootStyles={'display: block;'}
          />
        </div>
        <BaseFormControls
          type={'edit'}
          handleClickSubmit={handleSubmit}
          submitLabel='Update Collaborator'
          deleteConfirmationMessagePostfix={'collaborator'}
          resource='collaborators'
          id={props.id}
        />
      </div>
    </div>
  );
}

const CollaboratorEditWithForm = compose(
  withNotificationCenter(),
  withForm({ ...createConfig, mode: 'edit' }),
  withStyles(styles)
)(CollaboratorEdit);

// Wrapper component to extract route params and inject history from React Router v6
const CollaboratorEditWrapper = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const history = { push: navigate };
  return <CollaboratorEditWithForm {...props} id={id} history={history} />;
};

export default CollaboratorEditWrapper;